import {
  Companion_getInstance2eaghgpohvp5v as Companion_getInstance,
  PunchListItem1wbu5dz9rlo4k as PunchListItem,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { AccessInfoj60d6hx1qs8r as AccessInfo } from './supportModels.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_content(_this__u8e3s4) {
  return _this__u8e3s4.prop(PunchListItem_content_getInstance());
}
function get_required(_this__u8e3s4) {
  return _this__u8e3s4.prop(PunchListItem_required_getInstance());
}
function get_project(_this__u8e3s4) {
  return _this__u8e3s4.prop(PunchListItem_project_getInstance());
}
function get_order(_this__u8e3s4) {
  return _this__u8e3s4.prop(PunchListItem_order_getInstance());
}
function preparePunchListItemFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [PunchListItem__id_getInstance(), PunchListItem_project_getInstance(), PunchListItem_lineItem_getInstance(), PunchListItem_scope_getInstance(), PunchListItem_order_getInstance(), PunchListItem_content_getInstance(), PunchListItem_required_getInstance(), PunchListItem_complete_getInstance(), PunchListItem_readBy_getInstance(), PunchListItem_isMinorAdjustment_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function PunchListItem_content$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function PunchListItem_content$_get_name_$ref_dm2ujq() {
  return (p0) => p0.k20();
}
function PunchListItem_content$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PunchListItem_content$_get_serializer_$ref_4joxcd() {
  return (p0) => p0.j2j();
}
function PunchListItem_content$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function PunchListItem_content$_get_annotations_$ref_ezxo7j() {
  return (p0) => p0.bz();
}
var PunchListItem_contentClass;
function PunchListItem_content() {
  if (PunchListItem_contentClass === VOID) {
    class $ {
      constructor() {
        PunchListItem_content_instance = this;
        var tmp = this;
        tmp.h7w_1 = lazy(PunchListItem_content$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i7w_1 = lazy(PunchListItem_content$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j7w_1 = lazy(PunchListItem_content$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.h7w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PunchListItem_content$_get_name_$ref_dm2ujq(), null);
        return tmp0.f2();
      }
      k7w(receiver) {
        return receiver.q7w_1;
      }
      m2j(receiver) {
        return this.k7w(receiver instanceof PunchListItem() ? receiver : THROW_CCE());
      }
      v7w(receiver, value) {
        return receiver.w7w(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PunchListItem() ? receiver : THROW_CCE();
        return this.v7w(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.i7w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PunchListItem_content$_get_serializer_$ref_4joxcd(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j7w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PunchListItem_content$_get_annotations_$ref_ezxo7j(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PunchListItem_content', VOID, VOID, [SerializableProperty()]);
    PunchListItem_contentClass = $;
  }
  return PunchListItem_contentClass;
}
var PunchListItem_content_instance;
function PunchListItem_content_getInstance() {
  if (PunchListItem_content_instance === VOID)
    new (PunchListItem_content())();
  return PunchListItem_content_instance;
}
function PunchListItem_required$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function PunchListItem_required$_get_name_$ref_3n6ano() {
  return (p0) => p0.k20();
}
function PunchListItem_required$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PunchListItem_required$_get_serializer_$ref_uzyilv() {
  return (p0) => p0.j2j();
}
function PunchListItem_required$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function PunchListItem_required$_get_annotations_$ref_hd5obb() {
  return (p0) => p0.bz();
}
var PunchListItem_requiredClass;
function PunchListItem_required() {
  if (PunchListItem_requiredClass === VOID) {
    class $ {
      constructor() {
        PunchListItem_required_instance = this;
        var tmp = this;
        tmp.x7w_1 = lazy(PunchListItem_required$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y7w_1 = lazy(PunchListItem_required$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z7w_1 = lazy(PunchListItem_required$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.x7w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PunchListItem_required$_get_name_$ref_3n6ano(), null);
        return tmp0.f2();
      }
      k7w(receiver) {
        return receiver.r7w_1;
      }
      m2j(receiver) {
        return this.k7w(receiver instanceof PunchListItem() ? receiver : THROW_CCE());
      }
      a7x(receiver, value) {
        return receiver.w7w(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PunchListItem() ? receiver : THROW_CCE();
        return this.a7x(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.y7w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PunchListItem_required$_get_serializer_$ref_uzyilv(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z7w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PunchListItem_required$_get_annotations_$ref_hd5obb(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PunchListItem_required', VOID, VOID, [SerializableProperty()]);
    PunchListItem_requiredClass = $;
  }
  return PunchListItem_requiredClass;
}
var PunchListItem_required_instance;
function PunchListItem_required_getInstance() {
  if (PunchListItem_required_instance === VOID)
    new (PunchListItem_required())();
  return PunchListItem_required_instance;
}
function PunchListItem_project$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function PunchListItem_project$_get_name_$ref_dnf8l6() {
  return (p0) => p0.k20();
}
function PunchListItem_project$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PunchListItem_project$_get_serializer_$ref_yynpn7() {
  return (p0) => p0.j2j();
}
function PunchListItem_project$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function PunchListItem_project$_get_annotations_$ref_2a16tt() {
  return (p0) => p0.bz();
}
var PunchListItem_projectClass;
function PunchListItem_project() {
  if (PunchListItem_projectClass === VOID) {
    class $ {
      constructor() {
        PunchListItem_project_instance = this;
        var tmp = this;
        tmp.b7x_1 = lazy(PunchListItem_project$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c7x_1 = lazy(PunchListItem_project$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d7x_1 = lazy(PunchListItem_project$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.b7x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PunchListItem_project$_get_name_$ref_dnf8l6(), null);
        return tmp0.f2();
      }
      k7w(receiver) {
        return receiver.m7w_1;
      }
      m2j(receiver) {
        return this.k7w(receiver instanceof PunchListItem() ? receiver : THROW_CCE());
      }
      e7x(receiver, value) {
        return receiver.w7w(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PunchListItem() ? receiver : THROW_CCE();
        return this.e7x(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.c7x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PunchListItem_project$_get_serializer_$ref_yynpn7(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d7x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PunchListItem_project$_get_annotations_$ref_2a16tt(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PunchListItem_project', VOID, VOID, [SerializableProperty()]);
    PunchListItem_projectClass = $;
  }
  return PunchListItem_projectClass;
}
var PunchListItem_project_instance;
function PunchListItem_project_getInstance() {
  if (PunchListItem_project_instance === VOID)
    new (PunchListItem_project())();
  return PunchListItem_project_instance;
}
function PunchListItem_order$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function PunchListItem_order$_get_name_$ref_uzupp7() {
  return (p0) => p0.k20();
}
function PunchListItem_order$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PunchListItem_order$_get_serializer_$ref_5k1q4e() {
  return (p0) => p0.j2j();
}
function PunchListItem_order$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function PunchListItem_order$_get_annotations_$ref_e3kbba() {
  return (p0) => p0.bz();
}
var PunchListItem_orderClass;
function PunchListItem_order() {
  if (PunchListItem_orderClass === VOID) {
    class $ {
      constructor() {
        PunchListItem_order_instance = this;
        var tmp = this;
        tmp.f7x_1 = lazy(PunchListItem_order$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g7x_1 = lazy(PunchListItem_order$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h7x_1 = lazy(PunchListItem_order$annotations$delegate$lambda);
        this.i7x_1 = 0.5;
        this.j7x_1 = '0.5';
      }
      k20() {
        var tmp0 = this.f7x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PunchListItem_order$_get_name_$ref_uzupp7(), null);
        return tmp0.f2();
      }
      k7w(receiver) {
        return receiver.p7w_1;
      }
      m2j(receiver) {
        return this.k7w(receiver instanceof PunchListItem() ? receiver : THROW_CCE());
      }
      k7x(receiver, value) {
        return receiver.w7w(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PunchListItem() ? receiver : THROW_CCE();
        return this.k7x(tmp, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.g7x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PunchListItem_order$_get_serializer_$ref_5k1q4e(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h7x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PunchListItem_order$_get_annotations_$ref_e3kbba(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PunchListItem_order', VOID, VOID, [SerializableProperty()]);
    PunchListItem_orderClass = $;
  }
  return PunchListItem_orderClass;
}
var PunchListItem_order_instance;
function PunchListItem_order_getInstance() {
  if (PunchListItem_order_instance === VOID)
    new (PunchListItem_order())();
  return PunchListItem_order_instance;
}
function PunchListItem__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function PunchListItem__id$_get_name_$ref_lelc7() {
  return (p0) => p0.k20();
}
function PunchListItem__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PunchListItem__id$_get_serializer_$ref_uy5ze6() {
  return (p0) => p0.j2j();
}
function PunchListItem__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function PunchListItem__id$_get_annotations_$ref_iwq7xu() {
  return (p0) => p0.bz();
}
var PunchListItem__idClass;
function PunchListItem__id() {
  if (PunchListItem__idClass === VOID) {
    class $ {
      constructor() {
        PunchListItem__id_instance = this;
        var tmp = this;
        tmp.l7x_1 = lazy(PunchListItem__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m7x_1 = lazy(PunchListItem__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n7x_1 = lazy(PunchListItem__id$annotations$delegate$lambda);
        this.o7x_1 = Companion_getInstance_0().m2p();
        this.p7x_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.l7x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PunchListItem__id$_get_name_$ref_lelc7(), null);
        return tmp0.f2();
      }
      k7w(receiver) {
        return receiver.l7w_1;
      }
      m2j(receiver) {
        return this.k7w(receiver instanceof PunchListItem() ? receiver : THROW_CCE());
      }
      e7x(receiver, value) {
        return receiver.w7w(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PunchListItem() ? receiver : THROW_CCE();
        return this.e7x(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.m7x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PunchListItem__id$_get_serializer_$ref_uy5ze6(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n7x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PunchListItem__id$_get_annotations_$ref_iwq7xu(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PunchListItem__id', VOID, VOID, [SerializableProperty()]);
    PunchListItem__idClass = $;
  }
  return PunchListItem__idClass;
}
var PunchListItem__id_instance;
function PunchListItem__id_getInstance() {
  if (PunchListItem__id_instance === VOID)
    new (PunchListItem__id())();
  return PunchListItem__id_instance;
}
function PunchListItem_lineItem$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function PunchListItem_lineItem$_get_name_$ref_w5gzdg() {
  return (p0) => p0.k20();
}
function PunchListItem_lineItem$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PunchListItem_lineItem$_get_serializer_$ref_i345yz() {
  return (p0) => p0.j2j();
}
function PunchListItem_lineItem$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function PunchListItem_lineItem$_get_annotations_$ref_8jdrtt() {
  return (p0) => p0.bz();
}
var PunchListItem_lineItemClass;
function PunchListItem_lineItem() {
  if (PunchListItem_lineItemClass === VOID) {
    class $ {
      constructor() {
        PunchListItem_lineItem_instance = this;
        var tmp = this;
        tmp.q7x_1 = lazy(PunchListItem_lineItem$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r7x_1 = lazy(PunchListItem_lineItem$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s7x_1 = lazy(PunchListItem_lineItem$annotations$delegate$lambda);
        this.t7x_1 = null;
        this.u7x_1 = 'null';
      }
      k20() {
        var tmp0 = this.q7x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PunchListItem_lineItem$_get_name_$ref_w5gzdg(), null);
        return tmp0.f2();
      }
      k7w(receiver) {
        return receiver.n7w_1;
      }
      m2j(receiver) {
        return this.k7w(receiver instanceof PunchListItem() ? receiver : THROW_CCE());
      }
      v7x(receiver, value) {
        return receiver.w7w(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PunchListItem() ? receiver : THROW_CCE();
        return this.v7x(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.r7x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PunchListItem_lineItem$_get_serializer_$ref_i345yz(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s7x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PunchListItem_lineItem$_get_annotations_$ref_8jdrtt(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PunchListItem_lineItem', VOID, VOID, [SerializableProperty()]);
    PunchListItem_lineItemClass = $;
  }
  return PunchListItem_lineItemClass;
}
var PunchListItem_lineItem_instance;
function PunchListItem_lineItem_getInstance() {
  if (PunchListItem_lineItem_instance === VOID)
    new (PunchListItem_lineItem())();
  return PunchListItem_lineItem_instance;
}
function PunchListItem_scope$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function PunchListItem_scope$_get_name_$ref_t4vgbl() {
  return (p0) => p0.k20();
}
function PunchListItem_scope$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PunchListItem_scope$_get_serializer_$ref_w6ou6g() {
  return (p0) => p0.j2j();
}
function PunchListItem_scope$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function PunchListItem_scope$_get_annotations_$ref_jfiaes() {
  return (p0) => p0.bz();
}
var PunchListItem_scopeClass;
function PunchListItem_scope() {
  if (PunchListItem_scopeClass === VOID) {
    class $ {
      constructor() {
        PunchListItem_scope_instance = this;
        var tmp = this;
        tmp.w7x_1 = lazy(PunchListItem_scope$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x7x_1 = lazy(PunchListItem_scope$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y7x_1 = lazy(PunchListItem_scope$annotations$delegate$lambda);
        this.z7x_1 = null;
        this.a7y_1 = 'null';
      }
      k20() {
        var tmp0 = this.w7x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PunchListItem_scope$_get_name_$ref_t4vgbl(), null);
        return tmp0.f2();
      }
      k7w(receiver) {
        return receiver.o7w_1;
      }
      m2j(receiver) {
        return this.k7w(receiver instanceof PunchListItem() ? receiver : THROW_CCE());
      }
      v7x(receiver, value) {
        return receiver.w7w(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PunchListItem() ? receiver : THROW_CCE();
        return this.v7x(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.x7x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PunchListItem_scope$_get_serializer_$ref_w6ou6g(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y7x_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PunchListItem_scope$_get_annotations_$ref_jfiaes(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PunchListItem_scope', VOID, VOID, [SerializableProperty()]);
    PunchListItem_scopeClass = $;
  }
  return PunchListItem_scopeClass;
}
var PunchListItem_scope_instance;
function PunchListItem_scope_getInstance() {
  if (PunchListItem_scope_instance === VOID)
    new (PunchListItem_scope())();
  return PunchListItem_scope_instance;
}
function PunchListItem_complete$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(7);
}
function PunchListItem_complete$_get_name_$ref_jfbd0a() {
  return (p0) => p0.k20();
}
function PunchListItem_complete$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PunchListItem_complete$_get_serializer_$ref_h8ym7n() {
  return (p0) => p0.j2j();
}
function PunchListItem_complete$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(7);
}
function PunchListItem_complete$_get_annotations_$ref_lebo8h() {
  return (p0) => p0.bz();
}
var PunchListItem_completeClass;
function PunchListItem_complete() {
  if (PunchListItem_completeClass === VOID) {
    class $ {
      constructor() {
        PunchListItem_complete_instance = this;
        var tmp = this;
        tmp.b7y_1 = lazy(PunchListItem_complete$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c7y_1 = lazy(PunchListItem_complete$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d7y_1 = lazy(PunchListItem_complete$annotations$delegate$lambda);
        this.e7y_1 = null;
        this.f7y_1 = 'null';
      }
      k20() {
        var tmp0 = this.b7y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PunchListItem_complete$_get_name_$ref_jfbd0a(), null);
        return tmp0.f2();
      }
      k7w(receiver) {
        return receiver.s7w_1;
      }
      m2j(receiver) {
        return this.k7w(receiver instanceof PunchListItem() ? receiver : THROW_CCE());
      }
      g7y(receiver, value) {
        return receiver.w7w(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PunchListItem() ? receiver : THROW_CCE();
        return this.g7y(tmp, (value == null ? true : value instanceof AccessInfo()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.c7y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PunchListItem_complete$_get_serializer_$ref_h8ym7n(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d7y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PunchListItem_complete$_get_annotations_$ref_lebo8h(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PunchListItem_complete', VOID, VOID, [SerializableProperty()]);
    PunchListItem_completeClass = $;
  }
  return PunchListItem_completeClass;
}
var PunchListItem_complete_instance;
function PunchListItem_complete_getInstance() {
  if (PunchListItem_complete_instance === VOID)
    new (PunchListItem_complete())();
  return PunchListItem_complete_instance;
}
function PunchListItem_readBy$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(8);
}
function PunchListItem_readBy$_get_name_$ref_opp1ae() {
  return (p0) => p0.k20();
}
function PunchListItem_readBy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PunchListItem_readBy$_get_serializer_$ref_epp1pd() {
  return (p0) => p0.j2j();
}
function PunchListItem_readBy$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(8);
}
function PunchListItem_readBy$_get_annotations_$ref_oziuh1() {
  return (p0) => p0.bz();
}
var PunchListItem_readByClass;
function PunchListItem_readBy() {
  if (PunchListItem_readByClass === VOID) {
    class $ {
      constructor() {
        PunchListItem_readBy_instance = this;
        var tmp = this;
        tmp.h7y_1 = lazy(PunchListItem_readBy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i7y_1 = lazy(PunchListItem_readBy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j7y_1 = lazy(PunchListItem_readBy$annotations$delegate$lambda);
        this.k7y_1 = emptySet();
        this.l7y_1 = 'emptySet()';
      }
      k20() {
        var tmp0 = this.h7y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PunchListItem_readBy$_get_name_$ref_opp1ae(), null);
        return tmp0.f2();
      }
      k7w(receiver) {
        return receiver.t7w_1;
      }
      m2j(receiver) {
        return this.k7w(receiver instanceof PunchListItem() ? receiver : THROW_CCE());
      }
      m7y(receiver, value) {
        return receiver.w7w(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PunchListItem() ? receiver : THROW_CCE();
        return this.m7y(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.i7y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PunchListItem_readBy$_get_serializer_$ref_epp1pd(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j7y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PunchListItem_readBy$_get_annotations_$ref_oziuh1(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PunchListItem_readBy', VOID, VOID, [SerializableProperty()]);
    PunchListItem_readByClass = $;
  }
  return PunchListItem_readByClass;
}
var PunchListItem_readBy_instance;
function PunchListItem_readBy_getInstance() {
  if (PunchListItem_readBy_instance === VOID)
    new (PunchListItem_readBy())();
  return PunchListItem_readBy_instance;
}
function PunchListItem_isMinorAdjustment$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(9);
}
function PunchListItem_isMinorAdjustment$_get_name_$ref_90aygr() {
  return (p0) => p0.k20();
}
function PunchListItem_isMinorAdjustment$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PunchListItem_isMinorAdjustment$_get_serializer_$ref_2wleac() {
  return (p0) => p0.j2j();
}
function PunchListItem_isMinorAdjustment$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(9);
}
function PunchListItem_isMinorAdjustment$_get_annotations_$ref_2xm6eo() {
  return (p0) => p0.bz();
}
var PunchListItem_isMinorAdjustmentClass;
function PunchListItem_isMinorAdjustment() {
  if (PunchListItem_isMinorAdjustmentClass === VOID) {
    class $ {
      constructor() {
        PunchListItem_isMinorAdjustment_instance = this;
        var tmp = this;
        tmp.n7y_1 = lazy(PunchListItem_isMinorAdjustment$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.o7y_1 = lazy(PunchListItem_isMinorAdjustment$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.p7y_1 = lazy(PunchListItem_isMinorAdjustment$annotations$delegate$lambda);
        this.q7y_1 = null;
        this.r7y_1 = 'null';
      }
      k20() {
        var tmp0 = this.n7y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PunchListItem_isMinorAdjustment$_get_name_$ref_90aygr(), null);
        return tmp0.f2();
      }
      k7w(receiver) {
        return receiver.u7w_1;
      }
      m2j(receiver) {
        return this.k7w(receiver instanceof PunchListItem() ? receiver : THROW_CCE());
      }
      s7y(receiver, value) {
        return receiver.w7w(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PunchListItem() ? receiver : THROW_CCE();
        return this.s7y(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.o7y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PunchListItem_isMinorAdjustment$_get_serializer_$ref_2wleac(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.p7y_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PunchListItem_isMinorAdjustment$_get_annotations_$ref_2xm6eo(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PunchListItem_isMinorAdjustment', VOID, VOID, [SerializableProperty()]);
    PunchListItem_isMinorAdjustmentClass = $;
  }
  return PunchListItem_isMinorAdjustmentClass;
}
var PunchListItem_isMinorAdjustment_instance;
function PunchListItem_isMinorAdjustment_getInstance() {
  if (PunchListItem_isMinorAdjustment_instance === VOID)
    new (PunchListItem_isMinorAdjustment())();
  return PunchListItem_isMinorAdjustment_instance;
}
//region block: exports
export {
  get_content as get_content1vw4q43mal60r,
  get_order as get_order3gxa8tjn23l9j,
  preparePunchListItemFields as preparePunchListItemFieldsn208pxa5rl4c,
  get_project as get_project33kl9j91bsmm2,
  get_required as get_requiredy5h1ix9e5mkz,
};
//endregion

//# sourceMappingURL=PunchListItemFields.mjs.map
